import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const propertyManagingAgentCard = buildAdditionalContactCard({
  contactType: 'propertyManagingAgent',
  contactLabel: 'Property Managing Agent',
  overrides: {
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Attorney, Assistant, etc',
      },
    },
  } satisfies ContactCardOverrides,
});
